export default __webpack_public_path__ + "static/media/farmerMan.db67589b.png";